import { FC } from "react";

import { SavedViewsMenu } from "@/domain/_shared/saved-view/components/saved-views-menu";

import { DatatableQuickSearch } from "../datatable-quicksearch";

import { DatatableDisplayOptionsButton } from "./datatable-display-options-button";
import { DatatableFilterButton } from "./datatable-filter-button";

function defaultValueIfUndefined<T>({ val, defaultVal }: { val: T | undefined; defaultVal: T }): T {
  if (val === undefined) {
    return defaultVal;
  }
  return val;
}

export interface ConfigurationViewConfig {
  quicksearch?: boolean;
  filterButton?: boolean;
  displayOptionsButton?: boolean;
  savedViewsMenu?: boolean;
}

export interface DatatableConfigurationViewProps {
  config?: ConfigurationViewConfig;
}

export const DatatableConfigurationView: FC<DatatableConfigurationViewProps> = ({ config = {} }) => {
  const shoulRenderQuicksearch = defaultValueIfUndefined<boolean>({ val: config.quicksearch, defaultVal: true });
  const shoulRenderFilterButton = defaultValueIfUndefined<boolean>({ val: config.filterButton, defaultVal: true });
  const shoulRenderDisplayOptionsButton = defaultValueIfUndefined<boolean>({
    val: config.displayOptionsButton,
    defaultVal: true,
  });
  const shouldRenderSavedViewsMenu = defaultValueIfUndefined<boolean>({
    val: config.savedViewsMenu,
    defaultVal: true,
  });

  return (
    <div
      className="max-w-screen relative flex h-[45px] shrink-0 items-center justify-between gap-2 border-b border-solid pl-4 pr-6 text-sm"
      data-testid="datatable-configuration-view"
    >
      <div className="flex flex-row items-center">{shoulRenderQuicksearch && <DatatableQuickSearch />}</div>
      <div className="flex flex-row items-center gap-2">
        <div className="flex flex-row items-center gap-2">{shouldRenderSavedViewsMenu && <SavedViewsMenu />}</div>
        <div className="flex flex-row items-center gap-2">{shoulRenderFilterButton && <DatatableFilterButton />}</div>
        <div className="flex flex-row items-center gap-2">
          {shoulRenderDisplayOptionsButton && <DatatableDisplayOptionsButton />}
        </div>
      </div>
    </div>
  );
};
